import type { AxiosInstance } from 'axios'
import { isErrorStatus } from '@audience-republic/audience-manager-shared/api/utils'
import type { CustomApiError } from '@audience-republic/audience-manager-shared/api/types'
import type { Integration } from './types'

export default (axios: AxiosInstance) => ({

  /**
   * Fetch integrations
   */
  async fetchAll(): Promise<Integration[]> {
    const { data, status } = await axios.sg.get(`/integration`)
    if (isErrorStatus(status)) {
      const apiError: CustomApiError = {
        name: 'Fetch integrations error',
        message: `Error doing fetch integrations`,
        status,
      }
      throw apiError
    }
    return data
  },

})
